var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.appClasses,attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }